
export const apiUrl="https://gourigold.in/app/public/api/"
// export const IMAGE='https://gourigold.in/app/'+'img/';
export const IMAGE='https://gourigold.in/app/public/'+'img/';

// authentication
export const OTPREQUEST='otp/request';
export const LOGIN='login';
export const REGISTER='register';
export const OTPVERIFIED = 'user/register/otpverified';
export const OTPRESEND = 'user/register/otpresend';
export const FORGETPASSWORD = 'user/forgetpassword';
export const CHANGEPASSWORD = 'user/update/password';
export const USERKYC = 'user/kyc';
export const PROFILEUPDATE='edit';
export const PROFILEVIEW='details';

 // pages
export const CONTACT = 'contact';
export const ABOUT = 'pages/2';
export const TERMSANDCONDITION = 'pages/3';
export const PAYMENT = 'pages/10'

 // wishlist
export const WISHLISTVIEW='wishlist';
export const WISHLISTADD = 'wishlist';
export const WISHLISTDELETE='wishlist';


// cart
export const CARTVIEW='cart/show';
export const CARTDELETE = 'cart/Delete';
export const CARTADD = 'cart'
export const CARTUPDATE = 'cart/update';


// Dashboard
export const CRAUSEL = 'home';
export const NAVIGATION = 'home/navigation' ;
export const LIVERATE = 'https://skymcx.in/NKCHAIN & ITEM INCHSsJSON.php';

// Address
export const GETADDRESS = 'address';
export const ADDADDRESS = 'address';
export const DELADDRESS = 'address';
export const EDITADDRESS = 'address';
export const STATE = 'state';
export const CITY = 'cities';

// Events
export const EVENTS = 'events';
export const MYEVENTS = 'events';

// Products
export const PRODUCTDETAILS = 'product';
export const CATEGORY = 'category';
export const SUBCATEGORY = 'subcategory';
export const SUBCATEGORYTYPE='subsubcategory';
export const PRODUCTLIST = 'productlist';
export const PRODUCTFILTERMENU='product/menu/edit';
export const PRODUCTFILTER = 'productlist';
export const ORDERBY = 'product/list?subsubcategory_id=';
export const PRICELIST = 'product/list/price';

export const SEARCH='product';
export const MERCHANT = 'BulianMerchant';
export const OFFER = 'offer';
export const VERIFY = 'offer/verify';
// order
export const ORDERHISTORY = 'checkout';
export const CHECKOUT = 'checkout';
export const BANNER = 'banner';
export const RELATEDPRODUCT = 'related-product';

export const productComment = 'product-comment';
export const productLike = 'product-like';
export const productCommentImageDelete = 'product-comment-image-delete'